import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConfirmationModal } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetLoginFailureModalTID = (parentTestId)=>getTestIds(parentTestId);
export const LoginFailureModal = (param)=>{
    let { title, message, dismissModal, testId } = param;
    const { t: commonTexts } = useLocaleKeys('common');
    const { LoginFailureModalTestIds } = useMemo(()=>GetLoginFailureModalTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        testId: LoginFailureModalTestIds.Root(),
        bi: {
            primaryButton: {
                name: 'login_failure_got_it'
            },
            secondaryButton: {
                name: 'login_failure_close'
            },
            closeButton: {
                name: 'login_failure_close'
            }
        },
        title: title,
        content: message,
        primaryButtonLabel: commonTexts.buttons.gotIt(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal
    });
};
